import getIsContactNumberIsNotValid from '../utils/getIsContactNumberIsNotValid';
import {getSelectedContactNumber, selectIsContactNumberRequired} from './selectors';

export const shouldShowContactNumberAfterAddressee = (state, displayContactNumberAfterAddressee) => {
  const selectedContactNumber = getSelectedContactNumber(state);
  const isContactNumberRequired = selectIsContactNumberRequired(state);
  const isContactNumberInvalid = getIsContactNumberIsNotValid(state);
  
  if (!displayContactNumberAfterAddressee) {
    return true;
  }
  
  return isContactNumberRequired && (selectedContactNumber === '' || isContactNumberInvalid);
};
